import axiosCreator, { AxiosRequestConfig } from 'axios'
import { APP_CONFIG } from './config'
import humps from 'humps'

const axiosRequestConfig: AxiosRequestConfig = {
  baseURL: APP_CONFIG.apiUrl,
  headers: {},
  transformResponse:
    axiosCreator.defaults.transformResponse &&
    Array.isArray(axiosCreator.defaults.transformResponse)
      ? [
          ...axiosCreator.defaults.transformResponse,
          (data) => humps.camelizeKeys(data),
        ]
      : [],
}

const appAxios = axiosCreator.create(axiosRequestConfig)

appAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Reject promise if usual error
    const errorResponse = error.response

    if (errorResponse && errorResponse.status === 401) {
    } else {
      return Promise.reject(error)
    }
  }
)

appAxios.interceptors.request.use(
  (config) => config,
  (error) => {
    Promise.reject(error)
  }
)

export default appAxios
